import EnrolmentsReducer from './EnrolmentsReducer';
export default EnrolmentsReducer;
